export const SHELL_TEST_IDS = {
  dashboard: {
    routes: 'shell.dashboard.view.routes',
  },
} as const;
